import { render, staticRenderFns } from "./MatricesDetails.vue?vue&type=template&id=6bf392e8&scoped=true&"
import script from "./MatricesDetails.vue?vue&type=script&lang=js&"
export * from "./MatricesDetails.vue?vue&type=script&lang=js&"
import style0 from "./MatricesDetails.vue?vue&type=style&index=0&id=6bf392e8&scoped=true&lang=scss&"
import style1 from "./MatricesDetails.vue?vue&type=style&index=1&id=6bf392e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf392e8",
  null
  
)

export default component.exports